import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { roofingSystemPages } from "@/data/roofingSystemContent";

const c = roofingSystemPages["single-ply-roofing"];

export const Route = createFileRoute("/services/single-ply-roofing")({
  head: () => ({
    meta: [
      { title: "Single-Ply Roofing Southern California | McKay Roofing & Solar" },
      { name: "description", content: c.heroSubtitle },
      { property: "og:title", content: "Single-Ply Roofing - McKay Roofing & Solar" },
      { property: "og:description", content: c.heroSubtitle },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/single-ply-roofing" }],
  }),
  component: () => <RoofingServicePage {...c} />,
});
